import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import ConsultationPage from "@/ConsultationPage";
import AdminPage from "@/AdminPage";
import FertilityNutritionPage from "@/FertilityNutritionPage";
import MaleFertilityNutritionPage from "@/MaleFertilityNutritionPage";
import FemaleFertilityNutritionPage from "@/FemaleFertilityNutritionPage";
import CoupleFertilityNutritionPage from "@/CoupleFertilityNutritionPage";
import BlogPage from "@/BlogPage";
import BlogPostPage from "@/BlogPostPage";
import PCOSLandingPage from "@/PCOSLandingPage";
import FitlyElitePage from "@/FitlyElitePage";
import FitlyPremiumPlusPage from "@/FitlyPremiumPlusPage";
import SuccessStoriesPage from "@/SuccessStoriesPage";
import NutritionAssessmentPage from "@/NutritionAssessmentPage";

import WhatsAppButton from "@/components/WhatsAppButton";
import SmartCtaBar from "@/components/SmartCtaBar";
import SmartTestimonialStrip from "@/components/SmartTestimonialStrip";
import LeadCapturePopup from "@/components/LeadCapturePopup";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/consultation" element={<ConsultationPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/fertility-nutrition" element={<FertilityNutritionPage />} />
          <Route path="/male-fertility-nutrition" element={<MaleFertilityNutritionPage />} />
          <Route path="/female-fertility-nutrition" element={<FemaleFertilityNutritionPage />} />
          <Route path="/couple-fertility-nutrition" element={<CoupleFertilityNutritionPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/pcos-consultation" element={<PCOSLandingPage />} />
          <Route path="/programs/elite" element={<FitlyElitePage />} />
          <Route path="/programs/premium-plus" element={<FitlyPremiumPlusPage />} />
          <Route path="/success-stories" element={<SuccessStoriesPage />} />
          <Route path="/assessment" element={<NutritionAssessmentPage />} />
        </Routes>
        <WhatsAppButton />
        <SmartTestimonialStrip />
        <SmartCtaBar />
        <LeadCapturePopup />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);
